import React, { useEffect, useState } from 'react';
import { withStyles } from "@mui/styles";
import { Styles } from "../../../../../config/design/styles";
import { Chip, useMediaQuery } from '@mui/material';
import {PiggyBank, BadgePlus, Star, Home, BadgeDollarSign, Sparkles, BadgePercent, PackageCheck} from "lucide-react";
import { useTranslation } from "react-i18next";
import {useNavigate, useSearchParams} from "react-router-dom";
import SubTitle from "../../../../components/elements/SubTitle";
import axios from "axios";
import { defaultVariables } from "../../../../../config";
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Checkbox from '@mui/material/Checkbox';
import Grid from "@mui/material/Grid2";

function FrontFiltersLinks({ classes, onFilterChange, industry, is_list,filter_data }) {
    const { t } = useTranslation();
    const isMobile = useMediaQuery((theme) => theme.breakpoints.down('md'));
    const [searchParams, setSearchParams] = useSearchParams();
    const [data, setData] = useState(filter_data);
    const navigation = useNavigate();

    const filters_empty = {
        "popular": false,
        "new": false,
        "economic": false,
        "pod": false,
        "categories": []
    };

    return (
        <>
            <div className="filters-holder">
                <Chip
                    icon={<BadgePlus />}
                    label={t('new')}
                    variant={"outlined"}
                    color={"default"}
                    onClick={() => navigation(`/${industry}/discover?new=true`)}
                />
                <Chip
                    icon={<Sparkles />}
                    label={t('popular')}
                    variant={"outlined"}
                    color={"default"}
                    onClick={() => navigation(`/${industry}/discover?popular=true`)}
                />
                <Chip
                    icon={<BadgePercent />}
                    label={t('economic')}
                    variant={"outlined"}
                    color={"default"}
                    onClick={() => navigation(`/${industry}/discover?economic=true`)}
                />
                <Chip
                    icon={<PackageCheck />}
                    label={t('pod')}
                    variant={"outlined"}
                    color={"default"}
                    onClick={() => navigation(`/${industry}/discover?pod=true`)}
                />
            </div>
        </>
    );
}

export default withStyles(Styles)(FrontFiltersLinks);